import axios from 'axios'
import { MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { Loading } from 'element-ui'

axios.defaults.withCredentials = false;
// create an axios instance
const service = axios.create({
  baseURL: process.env.baseApi, // api的base_url
  timeout: 120000 // request timeout
})
let LoadingInstance = null
// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (config.loading) {
    LoadingInstance = Loading.service({
      lock: true,
      text: '正在提交，请稍后...',
      spinner: 'el-icon-loading',
      fullscreen: false,
    });
  } else {
    LoadingInstance = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
  }
  if (store.getters.token) {
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['Authorization'] = 'Bearer ' + store.getters.token
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    LoadingInstance && LoadingInstance.close();
    return response
  },
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  //   if (parseFloat(response.code, 10) !== 200) {
  //     if (parseFloat(response.code, 10) === 5555) {
  //       // error.response.data = '令牌错误或已失效，你已被登出，请重新登录'
  //       MessageBox.confirm('令牌已失效，你已被登出，请重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     } else if (parseFloat(response.code, 10) === 5006) {
  //       store.dispatch('FedLogOut').then(() => {
  //         location.reload() // 为了重新实例化vue-router对象 避免bug
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response
  //   }
  // },
  error => {
    LoadingInstance && LoadingInstance.close();
    if (error.response) {
      if (parseFloat(error.response.data.code, 10) === 5555) {
        // error.response.data = '令牌错误或已失效，你已被登出，请重新登录'
        MessageBox.confirm('令牌已失效，你已被登出，请重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      } else if (parseFloat(error.response.data.code, 10) === 5006) {
        // error.response.data = '令牌错误或已失效，你已被登出，请重新登录'
        // MessageBox.confirm('令牌已失效，你已被登出，请重新登录', '确定登出', {
        //   confirmButtonText: '重新登录',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch('FedLogOut').then(() => {
        //     location.reload() // 为了重新实例化vue-router对象 避免bug
        //   })
        // })
        this.$router.replace({ name: 'personal' })
      } else {
        return Promise.reject(error.response.data)
      }
    } else {
      return Promise.reject(error)
    }


    // }
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js